import { baseClient } from "./baseRequest";

export type GeneratePreviewVideoRequest = {
  klydoIds: string[];
  itemId: string;
  pendulumLogo?: string;
  displayDuration: number;
  /**
   * Attach the finished video to the collection's Shopify product instead of
   * only returning its URL. Routes to the admin-only endpoint, and requires
   * `itemId` to be the bare collection id.
   */
  attachToProduct?: boolean;
};

export type GeneratePreviewVideoResponse = {
  videoUrl: string;
};

export type MediaGenerationApiClient = {
  generatePreviewVideo: ({
    klydoIds,
    itemId,
    pendulumLogo,
    displayDuration,
    attachToProduct,
  }: GeneratePreviewVideoRequest) => Promise<GeneratePreviewVideoResponse>;
};

const mediaGenerationApiClient: MediaGenerationApiClient = {
  generatePreviewVideo: async ({
    klydoIds,
    itemId,
    pendulumLogo,
    displayDuration,
    attachToProduct,
  }) => {
    return baseClient.post<GeneratePreviewVideoResponse>({
      // Two endpoints, not one flag: preview-video is open to the read roles
      // and can never publish, product-video is admin-only and always does.
      url: attachToProduct
        ? "/media-generation/product-video"
        : "/media-generation/preview-video",
      body: { klydoIds, itemId, pendulumLogo, displayDuration },
    });
  },
};

export default mediaGenerationApiClient;
